"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drivingLicenseType = void 0;
exports.drivingLicenseType = { "TWO_YEARS": { "name": { "code": "TWO_YEARS", "localize": { "en": "2 Years", "th": "2 ปี" } } }, "FIVE_YEARS": { "name": { "code": "FIVE_YEARS", "localize": { "en": "5 Years", "th": "5 ปี" } } }, "PERMANENT": { "name": { "code": "PERMANENT", "localize": { "en": "Permanent", "th": "ตลอดชีพ" } } } };
